module.exports = __webpack_public_path__ + "img/brief_picture_02.2a7760b0.png";